import {
    createApp
} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import '@/assets/css/plugins.css'
import '@/assets/sass/style.scss'
import '@/assets/js/bootstrap.bundle.min.js'
import 'aos/dist/aos.css'
import i18n from './i18n'

window.$ = window.jQuery = require('jquery');


createApp(App).use(i18n).use(store).use(router).mount('#app')